// Polyfill implementation is required as Edge 17.x with native implementation doesn't work.
// Importing without specifying the polyfill object, will result in polyfill detecting the native
// 'window.fetch' and if presents, will use the native.
// https://github.com/github/fetch#browser-support
import { fetch as fetchPolyfill } from 'whatwg-fetch';

export default class Spreedly3DSLifecycle {
    private readonly lifecycle: Spreedly.ThreeDS.Lifecycle;

    public constructor(
        private readonly continueBookingUrl: string,
        private readonly triggerCompletionUrl: string,
        lifecycleOption: LifecycleOption,
        private readonly transactionData: TransactionData) {
        this.lifecycle = new Spreedly.ThreeDS.Lifecycle(lifecycleOption);
    }

    public start(): void {
        console.log("3DS2 init");
        window.Spreedly.on('3ds:status', event => this.statusUpdates(event)); // use lambda to fix "this" scoping issues.
        this.lifecycle.start(this.transactionData);
    }

    private async statusUpdates(event): Promise<void> {
        console.log("status update received");
        console.log(event);
        if (event.action === 'succeeded' || (event.action === 'error' || (event.context && event.context.state === 'gateway_processing_failed'))) {
            console.log(event.action + ': continuing booking');
            const url = this.continueBookingUrl + '&transactionToken=' + event.token;
            window.location.href = url;
        } else if (event.action === 'finalization-timeout') {
            console.log('finalization timeout, showing alert');
            alert('Sorry, the credit card verification has timed out. Please press OK to reattempt verification.');
            window.location.reload();
        } else if (event.action === 'trigger-completion') {

            // 1. make a request to your backend to do an authenticated call to Spreedly to complete the request
            //    The completion call is `https://core.spreedly.com/v1/transactions/[transaction-token]/complete`
            // 2a. if the transaction is marked as "succeeded" finish your checkout and redirect to success page
            // 2b. if the transaction is marked "pending" and the required action is "challenge" you'll need to call finalize
            // `event.finalize(transaction)` with the transaction data from the authenticated completion call.

            console.log('triggering completion');
            const response = await fetchPolyfill(`${this.triggerCompletionUrl}&transactionToken=${event.token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: event.context ? JSON.stringify({ context: event.context }) : null // event.context defined in https://docs.spreedly.com/guides/3dsecure2/#handle-transaction-response
            });

            const transaction = await this.checkStatus(response);

            if (transaction.state === 'succeeded' || transaction.state === 'gateway_processing_failed') {
                console.log('completion had a result of ' + transaction.state);
                window.location.href = `${this.continueBookingUrl}&transactionToken=${event.token}`;
            } else if (transaction.state === 'pending' && transaction.required_action === 'challenge') {
                console.log('completion is still pending');
                event.finalize(transaction);

                const iframe = document.getElementById('challenge-window');
                if (iframe != null) {
                    console.log('opening challenge window due to transaction state');
                    iframe.className += ' -opened';
                } else {
                    throw new Error(`Couldn't find the challenge window`);
                }
            } else {
                throw new Error(`Unhandled transaction state: ${JSON.stringify(transaction)}`);
            }
        } else if (event.action == 'challenge') {
            const iframe = document.getElementById('challenge-window');
            if (iframe != null) {
                console.log('opening challenge window due to event action');
                iframe.className += ' -opened';
            } else {
                throw new Error(`Couldn't find the challenge window`);
            }
        }
    }

    private checkStatus(response): Promise<any> {
        if (response.ok) {
            const jsonResponse = response.json();
            console.log(jsonResponse);
            return jsonResponse;
        } else {
            console.log(response);
            throw new Error(response.statusText);
        }
    }
}
